import actionTypes from 'constants/action-types';

import { createRoutine } from 'redux-saga-routines';

/**
 * A redux action creator for upserting topojson files in our cache
 * @param {String} name - name of the topoJSON file (either MAP_TOPOJSON_PRESETS name or custom)
 * @param {Object} json - TopoJSON/GeoJSON object that will be added to the cache
 * @return {Object} - the action object
 */
export function upsertTopoJSON(name, json) {
  return {
    type: actionTypes.CACHE.UPSERT_TOPOJSON,
    payload: { name, json },
  };
}

export const loadTopoJSON = createRoutine(actionTypes.CACHE.LOAD_TOPOJSON);
